const STORAGE_KEY = 'app_locale';
const USER_SET_KEY = 'app_locale_user_set';

export const getStoredLocale = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'en';
  } catch {
    return 'en';
  }
};

export const setStoredLocale = (locale, userSet = false) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(locale || 'en').toLowerCase());
    if (userSet) localStorage.setItem(USER_SET_KEY, '1');
  } catch (_) { /* ignore */ }
};

export const hasUserSetLocale = () => {
  try {
    return localStorage.getItem(USER_SET_KEY) === '1';
  } catch {
    return false;
  }
};

/** Append ?locale= for database-driven content APIs. English is the base in DB. */
export const withLocale = (locale) => ({
  params: { locale: String(locale || 'en').toLowerCase() },
});
